import { render, staticRenderFns } from "./MyRights.vue?vue&type=template&id=3ba8e9ca&scoped=true&"
import script from "./MyRights.vue?vue&type=script&lang=js&"
export * from "./MyRights.vue?vue&type=script&lang=js&"
import style0 from "./MyRights.vue?vue&type=style&index=0&id=3ba8e9ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8e9ca",
  null
  
)

export default component.exports